'use strict';

var FaresOptimizerRejectModalController = function FaresOptimizerRejectModalController($scope, configurationService, momentService, criteriaRuleService) {
  $scope.notes = '';
  $scope.rejectionOptions = configurationService.getFoRejectionReasons();
  $scope.rejectionDateLimit = criteriaRuleService.getDefaultFieldValue('utc2date').startOf('day');
  $scope.updateCount = function (data) {
    $scope.selectedItemCount = data;
  };
  $scope.handleReject = function () {
    $scope.rejectModalData.authorizationNotes = $scope.notes;
    $scope.rejectModalData.ladderIds = $scope.fareRecommendationRecordKeyList;
    $scope.rejectCallback();
  };
  $scope.isFormDisabled = function () {
    return $scope.notes === undefined || $scope.notes === '';
  };
  $scope.handleResetState = function () {
    $scope.notes = '';
  };
};
FaresOptimizerRejectModalController.$inject = ['$scope', 'ConfigurationService', 'MomentService', 'CriteriaRuleService'];
module.exports = FaresOptimizerRejectModalController;